<div class="container mt-4">
  <h4 class="mb-3">Service credits</h4>
  <p class="text-muted small mb-4">
    Check remaining prepaid capacity for external services used by PPTGen.
  </p>

  <div class="row g-3">
    <div class="col-md-6">
      <div class="card h-100">
        <div class="card-body">
          <h5 class="card-title">Narakeet (TTS)</h5>
          <p class="card-text small text-muted">
            Uses <code>NARAKEET_API_KEY</code> from server config.
            Credits are billed in seconds of generated audio.
          </p>
          <button
            type="button"
            class="btn btn-primary"
            [disabled]="narakeetLoading"
            (click)="checkNarakeet()"
          >
            {{ narakeetLoading ? 'Checking…' : 'Check Narakeet credits' }}
          </button>

          <div *ngIf="narakeetError" class="alert alert-danger mt-3 mb-0 small">{{ narakeetError }}</div>

          <dl *ngIf="narakeet && !narakeetError" class="mt-3 mb-0 small">
            <dt>Available</dt>
            <dd>{{ formatSeconds(narakeet.creditSeconds) }}</dd>
            <dt *ngIf="narakeet.creditMinutes != null">Approx. minutes</dt>
            <dd *ngIf="narakeet.creditMinutes != null">{{ narakeet.creditMinutes }}</dd>
            <dt *ngIf="narakeet.plan">Plan</dt>
            <dd *ngIf="narakeet.plan">{{ narakeet.plan }}</dd>
            <dt *ngIf="narakeet.billingId">Billing id</dt>
            <dd *ngIf="narakeet.billingId"><code>{{ narakeet.billingId }}</code></dd>
            <dt *ngIf="narakeet.identity">API key identity</dt>
            <dd *ngIf="narakeet.identity"><code>{{ narakeet.identity }}</code></dd>
            <dt *ngIf="narakeet.checkedAt">Checked at</dt>
            <dd *ngIf="narakeet.checkedAt">{{ narakeet.checkedAt }}</dd>
          </dl>
        </div>
      </div>
    </div>

    <div class="col-md-6">
      <div class="card h-100">
        <div class="card-body">
          <h5 class="card-title">ChatGPT / OpenAI</h5>
          <p class="card-text small text-muted">
            Credit / usage check for OpenAI is not implemented yet. Use the OpenAI dashboard for billing and usage.
          </p>
          <button type="button" class="btn btn-outline-secondary" disabled>
            Check OpenAI credits (soon)
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
